<template>
  <div
    id="header-div"
    :class="skinColor === 'dark' ? 'headerDivColorDark' : 'headerDivColorWhite'"
  >
    <img
      class="logo-img"
      :src="require('@/assets/images/logo/debtia.svg')"
      width="125"
    >
    <b-navbar-nav class="nav align-items-center ml-auto locale forgot-password-locale">
      <locale />

    </b-navbar-nav>
  </div>
</template>

<script>
import locale from '@core/layouts/components/app-navbar/components/Locale.vue'
import useAppConfig from '@core/app-config/useAppConfig'
import {
  BNavbarNav,
} from 'bootstrap-vue'

export default {
  components: {
    locale,
    BNavbarNav,
  },
  data() {
    return {
      skinColor: '',
    }
  },
  created() {
    const { skin } = useAppConfig()
    this.skinColor = skin.value
  },
}
</script>
<style scoped>
#header-div {
  margin: 15px;
  padding: 10px;
  border-radius: 5px;
}

.headerDivColorWhite {
  background: white;
}

.headerDivColorDark {
  background: #303950;
}

.logo-img {
    display: inline-block;
    margin-bottom: 10px;
}

.forgot-password-locale {
  display: inline-block;
  float: right;
  margin-right: 20px;
  margin-top: 15px;
}
</style>
